import React from "react"

import withRouter from "../Common/withRouter"

//Import Breadcrumb
import Breadcrumbs from "../Common/Breadcrumb" // Static Breadcrumb
import DynamicBreadcrumb from "../Common/DynamicBreadcrumb"
import {
  Button,
  Card,
  CardBody,
  CardImg,
  CardText,
  CardTitle,
  Container,
} from "reactstrap"
import { appConstants } from "../../constants/app_constants"

const PageLayout = props => {
  document.title = ` ${props.pageName} | ` + appConstants.cName

  return (
    <React.Fragment>
      <div className="page-content non-auth-page-layout px-lg-3">
        <Container fluid className="layout-item">
          {/* <Breadcrumbs title={"Home"} breadcrumbItem={props.pageName} /> */}{" "}
          {/* Static Breadcrumb */}
          {props?.breadcrumbItems &&
            < DynamicBreadcrumb items={props?.breadcrumbItems} />
          }
          {/* Dynamic Breadcrumb */}
          {/* <Card className="dashboard-items-content">{props.children}</Card> */}
          {props.children}
        </Container>
      </div>
    </React.Fragment>
  )
}

PageLayout.propTypes = {}

export default withRouter(PageLayout)
